export default __webpack_public_path__ + "static/media/ri_facebook.919592e5.svg";